import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { ErrorHandler } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { DATE_FORMAT } from '@shared/constants/date-format.constant';
import { authInterceptor } from '@shared/interceptors/auth.interceptor';
import { retryInterceptor } from '@shared/interceptors/retry.interceptor';
import { correlationIdInterceptor } from '@shared/interceptors/correlation-id.interceptor';
import { TelemetryService } from '@core/monitoring/telemetry.service';
import { ThemeService } from '@shared/services/theme.service';
import { CustomPaginator } from '@shared/utils/pagination-configuration';
import { ptBR } from 'date-fns/locale';
import player from 'lottie-web/build/player/lottie_light';
import { provideLottieOptions } from 'ngx-lottie';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { routes } from './app.routes';

registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([authInterceptor, retryInterceptor, correlationIdInterceptor])
    ),
    provideAnimations(),
    provideDateFnsAdapter(DATE_FORMAT),
    provideEnvironmentNgxMask(),
    provideLottieOptions({
      player: () => player,
    }),
    { provide: MAT_DATE_LOCALE, useValue: ptBR },
    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        animation: 'pulse',
        loadingText: 'O conteúdo está sendo carregado!'
      },
    }),
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    {
      provide: MatPaginatorIntl,
      useClass: CustomPaginator,
    },
    ThemeService,
    {
      provide: ErrorHandler,
      useClass: TelemetryService
    }
  ]
};

